import { UserState } from './types'
import { Account, User } from '../../models'

export const enum UserPermission {
  ListingsCreate = 'listings:create',
  ListingsEdit = 'listings:edit',
  ListingsArchive = 'listings:archive',
  ListingsPublish = 'listings:publish',
  AccountsShowReports = 'accounts:showReports',
  AccountsShowTranslations = 'accounts:showTranslations',
  AccountsShowStore = 'accounts:showStore',
  AccountsHasHubSpotSync = 'accounts:hasHubSpotSync',
  AccountsShowMandates = 'accounts:showMandates',
  AccountsListingNotification = 'accounts:listingNotification',
  AccountsNewsLetters = 'accounts:newsLetters',
  AccountsBookMeeting = 'accounts:bookMeeting',
  AccountsOnboarding = 'accounts:onboarding',
  AccountsUpselling = 'accounts:upselling',
  AccountsSpecialOffers = 'accounts:specialOffers',
  AccountsReactivation = 'accounts:reactivation',
  AccountsHasListGloballySkin = 'accounts:hasListGloballySkin',
  AccountsHasConversation = 'accounts:hasConversation',
  AccountsShowChat = 'accounts:showChat',
  AccountsPowerBuyerNotification = 'accounts:powerBuyerNotification',
  AccountsHasOfficesWithoutAgents = 'accounts:hasOfficesWithoutAgents',
  AccountsHasEmailAlias = 'accounts:hasEmailAlias',
}

export const initialAccount: Account = {
  creationDate: '',
  email: '',
  hubSpotCompanyId: 0,
  id: 0,
  isArchived: false,
  logo: '',
  mainLanguage: '',
  name: [],
  originalId: '',
  regionalSettings: {
    countryISO: '',
    language: '',
    isMetric: false,
  },
  theme: {
    primaryColor: '',
    secondaryColor: '',
    favIcon: '',
    logo: '',
    smallLogo: '',
    noReplyEmailAddress: '',
    supportEmailAddress: '',
    title: '',
  },
  updateDate: '',
  updatedByAccountId: 0,
  updatedByUserId: 0,
  websiteUrl: '',
}

export const initialCurrentUser: User = {
  phone: '',
  accountsRoles: [],
  countryISO: '',
  createdByAccountId: 0,
  createdByUserId: 0,
  creationDate: '',
  culture: '',
  currencyId: '',
  email: '',
  fullName: '',
  id: 0,
  isArchived: false,
  isBlocked: false,
  isDeleted: false,
  lastLoginDate: '',
  loginFrequency: 0,
  mainLanguage: '',
  notificationSettings: {
    newListingEmail: false,
    newListingSMS: false,
    newLeadEmail: false,
    newLeadSMS: false,
    powerBuyerEligibleEmail: false,
    powerBuyerEligibleSMS: false,
  },
  overridden: false,
  profileCompleted: false,
  regionalSettings: {
    culture: '',
    countryISO: '',
    language: '',
    timezoneOffset: 0,
    timezoneName: '',
    currencyId: '',
    dateFormat: '',
    timeFormat: '',
    numberFormat: '',
    isMetric: false,
    languageExceptions: [],
  },
  registrationDate: '',
  registrationType: '',
  slug: '',
  status: '',
  timezoneOffset: 0,
  updateDate: '',
  updatedByAccountId: 0,
  updatedByUserId: 0,
  importId: 0,
  socialNetworks: [],
}

export const initialState: UserState = {
  account: initialAccount,
  currentUser: initialCurrentUser,
  permissions: [],
  fetchingSucceed: false,
  fetchingPending: false,
  patchingCurrentUser: false,
}
